import Vue from 'vue';
import { MediaQueries } from 'vue-media-queries';
import App from './App.vue';
const mediaQueries = new MediaQueries();

const node = document.querySelector('.js-configuration');

if (node) {
    new Vue({
        data: { ...node.dataset },
        render: (h) => h(App),
        mediaQueries
    }).$mount(node);
}
